import {Droppable} from "react-beautiful-dnd";
import React from "react";

/*
Génère le DOM pour les dropzones
 */
export const GEN_DROP_ZONES = (prefix = '', xMax = 19, yMax = 12) => {
    let droppableDOM = [];
    for(let x = 1; x < xMax + 1; x++){
        for(let y = 1; y < yMax + 1 ; y++){
            let droppableId = `${prefix}_drop${x}_${y}`;

            droppableDOM.push(
                <Droppable droppableId={droppableId} >
                    {(provided, snapshot) => (
                        <div className={`${droppableId} ${snapshot.isDraggingOver ? 'actif' : ''}`}
                             ref={provided.innerRef}
                             isDraggingOver={snapshot.isDraggingOver}
                        >{provided.placeholder}</div>)}
                </Droppable>
            )
        }
    }
    return droppableDOM
}
